/* eslint-disable comma-dangle, prefer-regex-literals, no-irregular-whitespace */

const SPACES = '\u00A0\u202F '
const LQUOTE = '«„‚'
const RQUOTE = '»“‘'
const TAG = '.tf\\d+.'
const POSSIBLE_START = `(^|[${SPACES}${LQUOTE}"\\(]|${TAG})`
const POSSIBLE_END = `(?=[\\s.,;:?!"'${RQUOTE}\\)]|$|${TAG})`
const POSSIBLE_SPACE = `[${SPACES}]?`
const SOFT_HYPHEN = '\u00AD'

const toRegExp = str => str.split(' ').join('|')

const PREPOSITIONS = toRegExp('в во въ к ко къ о об обо объ с со cъ у без для до за из изъ на над от отъ по под при про меж из-за перед передо подо надо')
const CONJUNCTIONS = toRegExp('а да и или но как')
const BEFORE_PARTICLES = toRegExp('не ни')
const AFTER_PARTICLES = toRegExp('б бы ли ль же ж')

module.exports = [{
  name: 'ru/nbsp/shorties',
  handler: text => {
    const replacement = '$1$2 '
    const re = new RegExp(`(^|[^а-яё${SOFT_HYPHEN}]+)(${PREPOSITIONS}|${CONJUNCTIONS}|${BEFORE_PARTICLES})[\\n\\t ]+`, 'gim')

    return text
      .replace(re, replacement)
      .replace(re, replacement)
  },
},
{
  name: 'ru/nbsp/orphanInitials',
  handler: text => {
    const captialLetterWithDot = '([А-ЯЁ])\\.'

    const re = new RegExp(
      POSSIBLE_START +
      captialLetterWithDot + POSSIBLE_SPACE +
      captialLetterWithDot + POSSIBLE_END, 'gm'
    )

    return text.replace(re, '$1$2. $3.')
  },
}, {
  name: 'ru/nbsp/afterInitials',
  handler: text => {
    const captialLetterWithDot = '([А-ЯЁ])\\.'
    const titleCasedWord = '([А-ЯЁ][а-яё]+)'

    const re = new RegExp(
      POSSIBLE_START +
      titleCasedWord + POSSIBLE_SPACE +
      captialLetterWithDot + POSSIBLE_END, 'gm'
    )

    return text.replace(re, '$1$2 $3.')
  },
},
{
  name: 'ru/nbsp/because',
  handler: text => text
    .replace(/([а-яё]+)\s+(что)/gim, '$1 $2')
    .replace(/,\s*(что)\s+/gim, ', $1 '),
},
{
  name: 'common/nbsp/shorties',
  handler: text => {
    const replacement = '$1$2 '
    const re = new RegExp(`(^|[^a-z${SOFT_HYPHEN}]+)(a|an|as|and|&|at|but|by|for|in|no|not|of|or|per|the|to)[\\n\\t ]+`, 'gim')

    return text
      .replace(re, replacement)
      .replace(re, replacement)
  },
}, {
  name: 'ru/nbsp/abbrHack',
  handler: text => {
    const lowerCasedLetter = '([а-яё])'
    const lowerCasedLetterWithDot = lowerCasedLetter + '\\.'

    const re = new RegExp(
      POSSIBLE_START +
      lowerCasedLetterWithDot + POSSIBLE_SPACE + lowerCasedLetterWithDot +
      POSSIBLE_END, 'gm'
    )

    return text.replace(re, '$1$2.\u00A0$3.')
  },
}, {
  name: 'common/other/nonbreakingHyphens',
  handler: text => text.replace(/-/g, '‑'),
}, {
  name: 'common/other/nonbreakingThinSpace',
  handler: text => text.replace(/(\d{1,3}) (\d{3})([  ][a-zа-яё]+)/ig, '$1\u202F$2$3'),
}, {
  name: 'ru/nbsp/mdash',
  index: '10',
  handler: text => text.replace(/([a-zа-яё0-9]+) —/ig, '$1 —'),
}, {
  name: 'common/nbsp/mdashJoining',
  handler: text => text.replace(/([a-zа-яё0-9]+)—/ig, '$1\u2060—'),
}, {
  name: 'ru/nbsp/beforeParticles',
  handler: text => {
    const replacement = '$1 $2'
    const re = new RegExp(`([а-яё]) (${AFTER_PARTICLES})(?=[  .,;:?!"‘“»$])`, 'gim')
    const re2 = new RegExp(`([а-яё]) (${AFTER_PARTICLES})$`, 'gim')

    return text
      .replace(re, replacement)
      .replace(re, replacement)
      .replace(re2, replacement)
  }
}, {
  name: 'ru/nbsp/afterNumber',
  handler: text => {
    const re = new RegExp('(^|\\s)(\\d{1,5}) (г\\.|[а-яё]+)', 'gi')
    const years = ['год', 'г.', 'года', 'годы', 'годов', 'годам', 'годах', 'годами']

    return text.replace(re, (_, p1, p2, p3) => {
      const isYear = /(19|20|21)[0-9][0-9]/.test(p2)

      if (isYear && !years.includes(p3.toLowerCase())) {
        return `${p1}${p2} ${p3}`
      }

      return `${p1}${p2}\u00A0${p3}`
    })
  },
}]
